import httpUtils from '../../utils/HttpUtils'

class ActivitySupervisorService {

  //获取活动工长列表信息
  async list(activityId = '') {
    let result = null;
    try {
      result = await httpUtils.post('/activity/supervisor/list',{activityId})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }
}
export default new ActivitySupervisorService()
